import { CircleIcon } from "@icons/CircleLeft";

export function OptionCircleIcon({ color }: { color: string }) {
    return <CircleIcon color={color} />;
}
